import { FlagDefinition } from '../../types/agentTypes'
import { axiosClient } from '../axiosClient'

export const flagFunctions = {
  /**
   * Fetch the active flag classifiers. See `GET /api/flags/`. Used by the
   * assistant editor to render one switch per flag; an agent stores the flags
   * it opts out of in `excluded_flag_types`.
   */
  fetchFlags: async (): Promise<FlagDefinition[]> => {
    return await axiosClient.get('api/flags/')
  },
}
